import { TFetchConverter } from 'data/types/convertor.types';
import {
  TAnimalFieldVisibilityDB,
  TAnimalFieldVisibilityUI,
} from 'data/types/animalFieldVisibility.types';

export const animalFieldVisibilityConverter: TFetchConverter<
  TAnimalFieldVisibilityUI,
  TAnimalFieldVisibilityDB
> = {
  fromDb: data => ({
    // A config set that pre-dates the tri-state has no hidden list. Nothing hidden is both the
    // correct reading and the behaviour residents have always had, so a missing list must never
    // fail closed.
    hiddenRequirements: data?.hiddenRequirements || [],
    hideDocumentsSection: !!data?.hideDocumentsSection,
  }),
};
